<template>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    :pagination="false"
    @resizeColumn="handleResizeColumn"
    class="mb40"
  >
    <template #colType="{text}">
      <span>{{ text.colType - 0 ? '自动' : '手动' }}</span>
    </template>
    <template #title="{text}">
      <div class="w200">{{ text }}</div>
    </template>
    <template #SEO="{text}">
      <div class="w200">{{ text }}</div>
    </template>
    <template #status="{text}">
      <a-popconfirm
        :title="`是否${text.status ? '禁用' : '启用'}?`"
        ok-text="确定"
        cancel-text="取消"
        @confirm="
          () => col_activeCol_post({ ...text, status: text.status ? 0 : 1 })
        "
        @cancel="cancel"
      >
        <a-switch
          checked-children="启用"
          un-checked-children="禁用"
          :checked="text.status - 0 ? true : false"
        />
      </a-popconfirm>
    </template>
    <template #deal="{text}">
      <div class="tal">
        <a-button
          type="link"
          @click="jumpPage('CollectionDetail', { ...text, ...searchParams })"
          >编辑</a-button
        >
        <a-button type="link" @click="() => col_queryColLog_post({ ...text })"
          >日志</a-button
        >
        <a-popover title="" trigger="click" v-if="text.showDel">
          <template #content>
            <a-popconfirm
              title="是否确定删除该商品?"
              ok-text="确定"
              cancel-text="取消"
              trigger="click"
              @confirm="() => deleteFun({ ...text })"
              @cancel="cancel"
            >
              <a-button type="link" v-if="text.showDel">删除</a-button>
            </a-popconfirm>
          </template>
          <a-button type="link"><EllipsisOutlined /></a-button>
        </a-popover>
      </div>
    </template>
  </a-table>
</template>
<script>
import { inject, toRefs, ref } from 'vue'
import { EllipsisOutlined } from '@ant-design/icons-vue'
export default {
  components: {
    EllipsisOutlined
  },
  setup() {
    const columns = ref([
      {
        title: '编码',
        dataIndex: 'colId',
        key: 'colId',
        resizable: true,
        width: 100,
        align: 'center'
      },
      {
        title: '标题',
        dataIndex: 'title',
        key: 'title',
        width: 150,
        resizable: true,
        align: 'center',
        slots: { customRender: 'title' }
      },
      {
        title: 'SEO',
        dataIndex: 'seoUrl',
        key: 'seoUrl',
        resizable: true,
        width: 100,
        align: 'center',
        slots: { customRender: 'SEO' }
      },
      {
        title: 'Shopfiy对应ID',
        dataIndex: 'shopifyCollectionId',
        key: 'shopifyCollectionId',
        resizable: true,
        align: 'center',
        width: 180
      },
      {
        title: '同步人',
        dataIndex: 'creatorName',
        key: 'creatorName',
        resizable: true,
        align: 'center',
        width: 120
      },
      {
        title: '同步时间',
        dataIndex: 'syncTime',
        key: 'syncTime',
        align: 'center',
        width: 120
      }
    ])
    return {
      handleResizeColumn: (w, col) => {
        col.width = w
      },
      columns,
      ...toRefs(inject('initState'))
    }
  }
}
</script>
